import {
  CENTER_INITIATED_REPATRIATIONS_TRANSACTIONS_CREATE_REQUEST,
  CENTER_INITIATED_REPATRIATIONS_TRANSACTIONS_CREATE_SUCCESS,
  CENTER_INITIATED_REPATRIATIONS_TRANSACTIONS_CREATE_FAILURE,
} from './types/CenterInitiatedRepatriationsTransactionsCreateActionsTypes';

export function postCenterInitiatedRepatriationsTransactionsCreateRequestActionCreator(context,
  newDepartureDateTime,
  newDescription,
  newInboundImpc,
  newInboundOperator,
  newOutboundImpc,
  newOutboundOperator,
  newPlannedArrivalDateTime,
  newQuantity) {
  return {
    type: CENTER_INITIATED_REPATRIATIONS_TRANSACTIONS_CREATE_REQUEST,
    payload: {
      appContext: context,
      params: {
        departureDateTime: newDepartureDateTime,
        description: newDescription,
        inboundImpc: newInboundImpc,
        inboundOperator: newInboundOperator,
        outboundImpc: newOutboundImpc,
        outboundOperator: newOutboundOperator,
        plannedArrivalDateTime: newPlannedArrivalDateTime,
        quantity: newQuantity,
      },
    },
  };
}

export function postCenterInitiatedRepatriationsTransactionsCreateSuccessActionCreator(data) {
  return {
    type: CENTER_INITIATED_REPATRIATIONS_TRANSACTIONS_CREATE_SUCCESS,
    payload: data,
  };
}

export function postCenterInitiatedRepatriationsTransactionsCreateFailureActionCreator(error) {
  return {
    type: CENTER_INITIATED_REPATRIATIONS_TRANSACTIONS_CREATE_FAILURE,
    payload: error,
    error: true,
  };
}
